import React, { Component } from "react";
import configs from "../../Config.json"
import {Row,Col, Card, Accordion, Button, Table, Spinner, Alert} from 'react-bootstrap';
import {Link} from "react-router-dom";

//resources
class SearchDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            eventos: [],
            setdatos: [],
            mesAño: [],
            busqueda: '',
            eventosOriginal: [],
            searching: true,
            isLoaded: false,
            showing: true,
            handleImage: true,
            mostrar: false
        };
        this.filtrarMesAño = this.filtrarMesAño.bind(this);

    }
    
    async  componentDidMount() {

        const busquedaCleaned = this.props.busqueda.replace(/[&\\#,+()$~%.'":*?<>{}]/g, '');

        const response = await fetch(configs[0].host+'/eventsClub/getEventList?countryId='+ this.props.idPais +'&eventTypeId=-1&eventId='+busquedaCleaned+'&eventName=', { method: 'GET', headers:{"token": process.env.REACT_APP_API_TOK} })
        const json = await response.json()
        if (json !== null) {
            if (json.errorCode !== "404") {
                this.setState({eventos: json.events, eventosOriginal: json.events, isLoaded: true, mostrar: true})
            } else {
                this.setState({mostrar: null, isLoaded: true})
            }
        } else {
            console.log("errorNull")
            this.setState({mostrar: null, isLoaded: true})
        }

    }


    render() {

        let meses =["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];
        //Retorna meses y años sin repetirse de todas las fechas que se han ingresado.
        let mesAño = this.filtrarMesAño(this.state.eventos);
        
        let eventos = this.state.eventos;
        let varPais = this.props.varPais;
        let idPais = this.props.idPais;
        let urlPais = this.props.urlPais;

        //Cuando el input del search cambie a onchange sera true
        let searching = this.state.searching;

        return (
            <div className="clubes--row-list">{
            (this.state.isLoaded)?    
                (this.state.mostrar) ?
                    
                    <div className="container">

                        <Row>
                        
                            <Col sm={12}>
                                <h5 className="text-center m-4" style={{color:"#545454"}}>
                                Aqui esta tu evento
                                </h5>
                                {mesAño.map(
                                function(mes) {
                                    return(
                                    <div key={`${meses[mes.mes]}-${mes.año}`}>
                                        {/** Si es true abrira todos los acordiones */}
                                        <Accordion { ...(searching ? { activeKey: `${meses[mes.mes]}-${mes.año}`} : {} )} >
                                        
                                        <Card.Header className="clubes--accordion-header">
                                        <Accordion.Toggle as={Button} className="clubes--accordion-button clubes--accordion-button" variant="link" eventKey={`${meses[mes.mes]}-${mes.año}`}>
                                            {meses[mes.mes] + ' - ' + mes.año}
                                        </Accordion.Toggle>
                                        </Card.Header>

                                        {
                                        <Accordion.Collapse eventKey={`${meses[mes.mes]}-${mes.año}`}>
                                            <Card.Body>
                                            <Table borderless hover size="sm">
                                                <tbody>
                                        {
                                            eventos.map( 
                                            
                                            function(evento){
                                                const f = new Date(evento.eventdate);

                                                if (f.getMonth() === mes.mes && f.getUTCFullYear() === mes.año) {
                                                
                                                return (
                                                    
                                                      <tr key={evento.eventid} className="text-center clubes--table-tr">
                                                        
                                                        <td className="clubes--td-idevento pt-4 clubes--table-name">{`${evento.eventid}`}</td>
                                                          <td className="clubes--td-name pt-4">
                                                          <Link className="clubes--table-link" key={evento.eventid} to={
                                                                {
                                                                    pathname: 'detalle-evento/'+evento.eventid,
                                                                    state: {
                                                                        eventoName: evento.name,
                                                                        eventoFecha: evento.eventdate,
                                                                        eventoTipo: evento.evtTypedescription,
                                                                        eventoId: evento.eventid,
                                                                        varPais: varPais,
                                                                        eventTypeId: evento.eventtypeid,
                                                                        totalItems: evento.items,
                                                                        idPais: idPais,
                                                                        urlPais: urlPais
                                                                    }
                                                            }}>
                                                                <p className="clubes--table-name">
                                                                    {`${evento.name}`}
                                                                </p>
                                                            </Link>  
                                                          </td>
                                                        <td className="clubes--td-descevento pt-4 clubes--table-name">{`${evento.evtTypedescription}`}</td>
                                                        
                                                      </tr>
                                                )
                                                }else{
                                                    return null;
                                                }               
                        
                                            }
                                
                                            )
                                        }
                                            </tbody>
                                            </Table>
                                        </Card.Body>
                                        </Accordion.Collapse>
                                        }
                                        </Accordion>
                                    </div>
                                    )
                                }
                                )
                                
                            }
                        </Col>

                        </Row>
                        
                    {/** Fin */}
                    </div>

                : <Alert variant={"danger"} className="m-4">
                    Lo sentimos, no podimos encontrar el evento.
                </Alert>
            : <Row className="d-flex justify-content-center">
                <Spinner  animation="border" role="status" variant="center">
                <span className="sr-only">Loading...</span>
                </Spinner>
            </Row>
        }
        <hr></hr>
        <div className="container">
        
            <Row className="d-flex justify-content-center" > 
                <Col xs={12} sm={12} lg={12} className="clubes--col mt-3 justify-content-end">
                    <Link className="btnsNav float-right bold d-flex justify-content-end align-item-center" to={`${this.props.varPais}`} >Regresar a búsquedas <div className="clubes--back-icon"></div></Link> 
                </Col>

            </Row>
        </div>
        </div> 
        );
    }

    filtrarMesAño(eventos){
      let arrayMesAño = [];
      //De todos los eventos obtenemos todos los meses y años 
      eventos.map(
        function(evento){
          const fechaEvento = new Date(evento.eventdate);
          return arrayMesAño.push( {mes: fechaEvento.getMonth(),año: fechaEvento.getFullYear()} )
        }
      );
      
      var hash = {};
      //De el areglo antes encontrado obtenemos mes y año sin repetirse
      arrayMesAño = arrayMesAño.filter(function(item){
        var exist = !hash[item.mes];
        hash[item.mes] = true;
        return exist;
      });

      return arrayMesAño;
    }

}

export default SearchDetail;